
export const apiUrl = 'https://api.diveaaus.org';
export const uploadsUrl = 'https://uploads.diveaaus.org';
